<template>
  <v-card class="elevation-0 indigo lighten-5 pb-1">
    <v-card-title class="pl-0">XSLT</v-card-title>
    <v-card-text
      class="ml-0 vop--ace-editor-container"
      :style="{ height: editorHeight }"
    >
      <div ref="xsltEditor" class="vop--ace-editor"></div>
    </v-card-text>
    <v-card-actions class="pl-0"> </v-card-actions>
  </v-card>
</template>

<script>
import ace from "brace";
import "brace/mode/json";
import "brace/theme/eclipse";
import "brace/ext/searchbox";
import * as utils from "@/Shared/utils";
import messages from "@/XVAT/messages.json";

export default {
  name: "XSLTEditor",
  props: ["value"],
  computed: {
    editorHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "30vh";
        case "sm":
          return "30vh";
        case "md":
          return "38vh";
        case "lg":
          return "38vh";
        case "xl":
          return "50vh";
        default:
          return "30vh";
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    /**
     * Initialize the editor
     * */
    initialzieEditor() {
      let editor = ace.edit(this.$refs.xsltEditor);
      editor.setReadOnly(false);
      this.$refs.xsltEditor.style.backgroundColor = "floralwhite";
      editor.setTheme("ace/theme/eclipse");
      editor.getSession().setMode("ace/mode/xml");
      this.initXSLTValue();
      var vm = this;
      editor.session.on("change", function(delta, editor) {
        let xsltValue = editor.getValue();
        let xlstSingleLine = utils.convertXMLToSingleLine(xsltValue);
        vm.$emit("input", xlstSingleLine);
        // delta.start, delta.end, delta.lines, delta.action
      });
      editor.resize(true);
    },

    /**
     * Initializes XSLT value
     * */
    initXSLTValue() {
      if (this.value && !this.$lodash.isNull(this.value)) {
        let xsltMultiLine = utils.convertXMLToMultiLine(this.value);
        let editor = ace.edit(this.$refs.xsltEditor);
        editor.session.setValue(xsltMultiLine);
      }
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages;
  },
  updated() {},
  mounted() {
    this.initialzieEditor();
  }
};
</script>
<style lang="scss" scoped>
.vop--ace-editor-container {
  position: relative;
}

.vop--ace-editor {
  position: absolute;
  top: 20px;
  bottom: 20px;
  left: 20px;
  right: 20px;
}

.vop--ace-editor .ace_search_field,
.ace_searchbtn:last-child {
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/XVAT/Rule/XSLTEditor.vue